import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { A11y, Navigation } from "swiper/modules"
// Swiper CSS comes from application.bootstrap.scss (swiper-bundle.min); importing
// it here makes esbuild emit its own application.css, clobbering the sass bundle.

export default class extends Controller {
  connect() {
    this.initSwiper()
  }

  disconnect() {
    // Clean up swiper instance when the element is removed from the DOM
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.element.querySelector('.testimonial-swiper'), {
      modules: [A11y, Navigation],

      // Responsive breakpoints
      breakpoints: {
        // Mobile (1 slide)
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        // Tablet (2 slides)
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // Desktop (3 slides)
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      },
      
      // Optional parameters
      loop: true,
      grabCursor: true,
      
      // Navigation arrows
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
      
      // Auto height
      autoHeight: true,
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      }
    })
  }
}
